
define('app/dashboard/leagues/leaguesApp',[
	'jquery',
	'underscore',
	'backbone',
	'known/knownUtil',
	'known/models/userModel',
	'known/models/productModel',
	'known/models/leagueInstanceModel',
	'known/collections/productCollection',
	'known/collections/leagueInstanceCollection',
	'known/views/productLeaguesView',
	'module'
], function(
		$, 
		_, 
		Backbone,
		KnownUtil,
		UserModel, 
		ProductModel,
		LeagueInstanceModel,
		ProductCollection, 
		LeagueInstanceCollection, 
		ProductLeaguesView, 
		module){
	var initialize = function(){
		var initialModels = KnownUtil.setupSideNav();
		var userModel = initialModels.userModel;
		
		var requestedLeaguesJSON = $.parseJSON(module.config().requestedLeaguesJSON);
		var requestedProdsJSON = $.parseJSON(module.config().requestedProductsJSON);
		
		var reqLeagueCollection = new LeagueInstanceCollection([], {userName : userModel.get("userName")});
		var reqProdCollection = new ProductCollection([], {userName : userModel.get("userName")});
		
		//Need to go through each one individually and look it up incase there are backbone relational conflicts
		_.each(requestedProdsJSON, function(product){
			product.id = product.sport.toUpperCase() + product.year;
			var prodModel = ProductModel.findOrCreate(product);
			reqProdCollection.add(prodModel);
		}, this);
		
		_.each(requestedLeaguesJSON, function(league){
			var lgInstanceModel = LeagueInstanceModel.findOrCreate(league);
			reqLeagueCollection.add(lgInstanceModel);
		}, this);
		
		reqProdCollection.each(function(product){
			var prodLgsView = new ProductLeaguesView({userModel: userModel, product: product, leagueCollection: reqLeagueCollection});
			$("#content > .wrapper").append(prodLgsView.render().el);
		});
	};
	
	return {
		initialize: initialize
	};
});